import PropTypes from "prop-types";
import { path, pathOr, isNil } from "ramda";
import { Link } from "@mui/material";

import { responsiveImage, replaceHost } from "utils/contentful";

import { Root, Item, Figure, StyledSkeleton, Image, Name } from "./styles";

const Menu = (props) => {
  const { pageModule, eventClick } = props;
  const menuItems = path(["fields", "menuItems"], pageModule);

  const renderMenuItem = (menuItem) => {
    if (isNil(menuItem)) {
      return null;
    }

    const { id } = menuItem.sys;
    const linkTo = pathOr("", ["fields", "linkTo"], menuItem);
    const linkText = pathOr("", ["fields", "linkText"], menuItem);
    const imageUrl = pathOr("", ["fields", "image", "fields", "file", "url"], menuItem);
    const imageTitle = pathOr("", ["fields", "image", "fields", "title"], menuItem);

    return (
      <Item key={id}>
        <Link href={eventClick ? replaceHost(linkTo) : null}>
          <Figure className="figure">
            <StyledSkeleton className="placeholder" variant="circular" />
            <Image srcSet={responsiveImage(imageUrl)} alt={imageTitle} />
          </Figure>
          <Name className="name" component="span">
            {linkText}
          </Name>
        </Link>
      </Item>
    );
  };

  return <Root>{menuItems.map((menuItem) => (menuItem.fields ? renderMenuItem(menuItem) : null))}</Root>;
};

Menu.propTypes = {
  pageModule: PropTypes.shape().isRequired,
  eventClick: PropTypes.bool.isRequired,
};

export default Menu;
